<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { mloc } from "module/utils";

  let {
    icon,
    altcolor,
    square,
    more,
    selected,
    title,
    disabled,
  }: {
    /** Text title */
    title: string;
    /** FontAwesome icon class */
    icon?: string;
    /** Use alternative color */
    altcolor?: boolean;
    /** No rounded corners */
    square?: boolean;
    /** Show "More" button */
    more?: boolean;
    /** Selected state */
    selected?: boolean;
    /** Disabled state */
    disabled?: boolean;
  } = $props();

  const dispatch = createEventDispatcher();
</script>

<li
  class:selected
  class:altcolor
  class:square
  class:more
  class:disabled
  on:click={(evt) => !disabled && dispatch("click", evt)}
  {title}
  tabindex="0"
>
  <span>
    {#if icon}<i class="fas {icon}"></i>{/if}
    {title}
  </span>
  {#if more}
    <i
      class="fas fa-caret-down"
      on:click|stopPropagation={() => !disabled && dispatch("clickMore")}
      title={mloc("FilterEditorOptionMoreOptions")}
      tabindex="0"
    ></i>
  {/if}
</li>

<style>
  li {
    display: flex;
    align-items: center;
    line-height: 1.8em;
    gap: 0.3em;
    border-radius: 4px;
    padding: 0 0.6em;
    background: rgba(255, 255, 255, 0.2);
    cursor: pointer;
    justify-content: space-between;
    border: none;
    margin-bottom: 0 !important;
  }

  li:active {
    box-shadow: inset 0 0 0 1px #0004;
  }

  .more {
    padding-right: 0;
  }
  .square {
    border-radius: 0;
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  li:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  .selected {
    background: rgba(0, 0, 0, 0.5);
    color: var(--color-light-2);
  }

  .selected:hover {
    background: rgba(0, 0, 0, 0.4);
  }

  /** Alternative colored sausage */

  li.altcolor {
    /* background: rgba(255, 166, 166, 0.35); */
    /* color: rgba(189, 0, 0, 0.66); */
    color: rgba(255, 166, 166, 0.7);
    background: transparent;
  }

  li.altcolor:hover {
    background: rgba(255, 166, 166, 0.7);
  }

  .selected.altcolor {
    background: rgba(189, 0, 0, 0.66);
    color: var(--color-light-2);
  }

  .selected.altcolor:hover {
    background: rgba(189, 0, 0, 0.4);
  }

  .fa-caret-down {
    border-radius: 0 4px 4px 0;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.04, 1);
    background: #0002;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    width: 24px;
    flex-shrink: 0;
  }

  .fa-caret-down:hover {
    background: #0003;
  }
  .fa-caret-down:active {
    box-shadow: inset 0 0 0 1px #0004;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
